import { Component, OnInit } from '@angular/core';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { Card } from 'primeng/card';
import { PessoaDetalhe } from '@/shared/components/pessoa/pessoa-detalhe/pessoa-detalhe';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { PessoaService } from '@/shared/services/pessoa.service';

interface DashboardTabOption {
    name: string;
    value: 'dados' | 'anexos';
}

interface AnexoItem {
    label: string;
    valor: string;
}

@Component({
    selector: 'app-dashboard-pre-prestador',
    imports: [Card, PessoaDetalhe, Select, FormsModule],
    templateUrl: './dashboard-pre-prestador.html',
    styleUrl: './dashboard-pre-prestador.scss'
})
export class DashboardPrePrestador implements OnInit {
    constructor(private readonly pessoaService: PessoaService) {}

    pessoa: Pessoa | undefined;

    options: DashboardTabOption[] = [
        { name: 'Dados Gerais', value: 'dados' },
        { name: 'Anexos', value: 'anexos' }
    ];

    selectedComponent: DashboardTabOption = this.options[0];

    anexos: AnexoItem[] = [];

    ngOnInit(): void {
        this.pessoa = this.pessoaService.getPessoa() ?? this.pessoaService.getPessoaReference() ?? undefined;

        this.extrairAnexos();
    }

    private extrairAnexos(): void {
        const fontes: unknown[] = [];

        const storedPrePrestador = sessionStorage.getItem('prePrestador');
        if (storedPrePrestador) {
            try {
                fontes.push(JSON.parse(storedPrePrestador));
            } catch {
                sessionStorage.removeItem('prePrestador');
            }
        }

        if (this.pessoa) {
            fontes.push(this.pessoa as unknown);
        }

        const anexosMap = new Map<string, string>();

        fontes.forEach((fonte) => {
            if (!fonte || typeof fonte !== 'object') return;

            Object.entries(fonte as Record<string, unknown>).forEach(([key, raw]) => {
                const valor = typeof raw === 'string' ? raw.trim() : '';
                if (!valor) return;

                const chave = key.toLowerCase();
                const ehCampoAnexo = chave.startsWith('anexo') || chave.includes('anexo') || chave.includes('documento') || chave.includes('link');

                if (!ehCampoAnexo) return;

                const label = this.formatarLabel(key);
                anexosMap.set(label, valor);
            });
        });

        this.anexos = Array.from(anexosMap.entries()).map(([label, valor]) => ({ label, valor }));
    }

    private formatarLabel(campo: string): string {
        const texto = campo
            .replace(/^anexo/i, 'Anexo ')
            .replace(/^link/i, 'Link ')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/_/g, ' ')
            .trim();

        return texto.charAt(0).toUpperCase() + texto.slice(1);
    }
}
